import { useEffect, useState } from "react";

type MaybeDisposable = {
  dispose?: () => void;
};

function useStore<T, P extends Array<unknown>>(
  Store: new (...args: P) => T,
  params: P,
  dispose?: () => void
): T {
  const [stateOfStore] = useState(() => {
    return {
      store: new Store(...params),
      params,
    };
  });

  const { store } = stateOfStore;

  useEffect(
    () => () => {
      (store as MaybeDisposable).dispose?.();
      dispose?.();
    },
    [dispose]
  );

  return store;
}

export default useStore;
